import type React from 'react';
import { observer } from 'mobx-react'
import styled from 'styled-components'

import { theme } from 'styles/theme'
import { SpinnerIcon } from 'components/Spinner/Spinner'
import type { OperationStatus } from 'models/common/OperationStatus'
import ErrorPage from 'pages/ErrorPage'

type FetchingWrapperProps = {
  fetchStatus: OperationStatus
  inProgressTitle: string
  errorMessagePrefix: string
  children: React.ReactNode
  onRetry?: () => Promise<void>
  Container?: React.FC<{ children: React.ReactNode }>
}

const ErrorOrSpinnerContainer = styled.div`
  block-size: 100%;
  inline-size: 100%;
  background-color: ${theme.colors.White};
  border: solid 1px ${theme.colors.MediumGrey};
  display: inline-flex;
  overflow: auto;
`

const FetchingWrapper: React.FC<FetchingWrapperProps> = ({
  fetchStatus,
  inProgressTitle,
  errorMessagePrefix,
  children,
  onRetry,
  Container = ErrorOrSpinnerContainer, 
}) => {
  if (fetchStatus.isSuccess) {
    return <>{children}</>;
  }

  const onRetryObj = onRetry ? { onRetry } : {};
  return (
    <Container>
      {fetchStatus.inProgress ? (
        <SpinnerIcon {...{ title: inProgressTitle }} />
      ) : fetchStatus.error ? (
        <ErrorPage
          error={fetchStatus.error}
          errorMessagePrefix={errorMessagePrefix}
          {...onRetryObj}
        />
      ) : null}
    </Container>
  );
};

export default observer(FetchingWrapper);
